import { set } from "lodash";

export const errorJsonHasErrors = (obj) => {
    for (let i in obj) {
        if (typeof obj[i] !== 'string') {
            if (errorJsonHasErrors(obj[i])) {
                return true
            }
        } else if (obj[i] !== "") {
            // console.log(obj[i])
            return true
        }
    }
    return false
}

export const errorCheckForm = () => {
    const elems = document.querySelectorAll("*")
    elems.forEach(elem => {
        if (elem.name !== undefined && elem.name !== null && elem.name !== "") {
            //console.log(elem.name)
            elem.focus();
            elem.blur();
        }
    })
}

export const errorClear = (obj) => {
    for (let i in obj) {
        if (typeof obj[i] !== 'string') {
            errorClear(obj[i])
        } else {
            obj[i] = ""
        }
    }
    return false
}

export const errorSet = (errors, setErrors, obj, i, err) => {
    if (i !== null) {
        obj += "[" + i + "]"
    }
    let e = set(errors, obj, err)
    setErrors(e)
    // console.log(obj)
    // console.log(err)
    //console.log(e)
    return e
}
export const errorSetPlus = (onError, errors, setErrors, obj, i, err) => {
    let e = errorSet(errors, setErrors, obj, i, err)
    //console.log(e)
    if (onError !== null) {
        onError(errorJsonHasErrors(e) ? "Errors" : "")
    }
}


// export const errorSet = (errors, errorsSet, obj, i, err) => {
//     if (i !== null) {
//         obj += "[" + i + "]"
//     }
//     return obj
//     let e = set(errors, obj, err)

//     setErrors(e)
//     console.log(e)
// // }

// const onError = (obj, err) {
//     let e = set(errors, obj, err)
//     setErrors(e)
// }




